const getters = {
  changeFixed: state => state.fixHeader.changeFixed,
  fixFooterBtn: state => state.fixHeader.fixFooterBtn,
}
export default getters
